/* @flow */

export function safeIndexOf<T>(collection : Array<T>, item : T) : number {
    for (let i = 0; i < collection.length; i++) {

        try {
            if (collection[i] === item) {
                return i;
            }
        } catch (err) {
            // pass
        }
    }

    return -1;
}

// eslint-disable-next-line no-unused-vars
export function noop(...args : Array<mixed>) {
    // pass
}



// WEBPACK FOOTER //
// ./node_modules/cross-domain-safe-weakmap/src/util.js